import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import FilterMenu from '@/components/ui/filter-menu';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

const TOOL_TYPES = ['Laser', 'Endmill'];

function ToolTypeFilter({ submenu }: { submenu?: boolean }) {
  const { appendSearchParam, removeSearchParam } = useSearchParamActions();

  return (
    <FilterMenu label="Tool Type" submenu={submenu}>
      <DropdownMenuItem onClick={() => removeSearchParam('toolType')}>
        All
      </DropdownMenuItem>
      {TOOL_TYPES.map((toolType) => (
        <DropdownMenuItem
          key={toolType}
          onClick={() => appendSearchParam('toolType', toolType)}
        >
          {toolType}
        </DropdownMenuItem>
      ))}
    </FilterMenu>
  );
}

export default ToolTypeFilter;
